/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'hourglass-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M21.5 24H20v-4.5a7.496 7.496 0 0 0-4.825-7A7.496 7.496 0 0 0 20 5.5V1h1.5a.5.5 0 0 0 0-1h-18a.5.5 0 0 0 0 1H5v4.5a7.496 7.496 0 0 0 4.825 7A7.496 7.496 0 0 0 5 19.5V24H3.5a.5.5 0 0 0 0 1h18a.5.5 0 0 0 0-1zM6 5.5V1h13v4.5a6.5 6.5 0 0 1-13 0zm6.5 7.5a6.504 6.504 0 0 1 6.475 6H6.025a6.504 6.504 0 0 1 6.475-6z"/>'
  }
})
